import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Camera, CameraPost, ConfigCamera } from '@classes/camera/camera';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CamerasService {

  constructor(
    private http: HttpClient
  ) { }

  /* ----------------------------------- GET ---------------------------------- */
  getCameras(): Observable<Camera[]> {
    return this.http.get<Camera[]>(`${environment.apiUrl}/cameras`, {
      headers: { authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}` },

    });
  }

  getConfigCamera(id: string): Observable<ConfigCamera> {
    return this.http.get<ConfigCamera>(`${environment.apiUrl}/cameras/${id}/config`,
      {
        headers: { authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}` },

      });
  }




  /* -------------------------------------------------------------------------- */

  /* ---------------------------------- POST ---------------------------------- */

  addCamera(camera: CameraPost) {
    return this.http.post(`${environment.apiUrl}/cameras`, camera);
  }
  /* -------------------------------------------------------------------------- */


  /* ----------------------------------- PUT ---------------------------------- */

  updateCamera(camera: CameraPost) {
    return this.http.put(`${environment.apiUrl}/cameras`, camera);
  }

  updateConfigCamera(id: string, config: ConfigCamera) {
    return this.http.put(`${environment.apiUrl}/cameras/${id}/config`, config);
  }
  /* -------------------------------------------------------------------------- */

}
